import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/not-found.tsx");
